import {
  Button,
  Col,
  FullWidthSpace,
  LabeledItem,
  Row,
  Space,
  Table,
  Title,
} from "melco-ui";
import { useTranslation } from "react-i18next";

import {

  useConfirm,
} from "melco-shared-logic";
import { useTransferLicense } from "../../hooks/licenses/useTransferLicense";



type ConfirmExecuteTransferLicenseButtonProps = {

  onCloseDrawer?: () => void;
  newSelectedUser: any;
  license: any;
};

export const ConfirmExecuteTransferLicenseButton: React.FC<
  ConfirmExecuteTransferLicenseButtonProps
> = ({ onCloseDrawer, newSelectedUser, license }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t("licenses.basic.detail.transfer.current"),
      dataIndex: "current",
      //width: 50
    },
    {
      title: t("licenses.basic.detail.transfer.new"),
      dataIndex: "new",
      //width: 50
    },
  ];

  const data = [
    {
      key: "user_name",
      current: license?.master_user_name ?? "",
      new: newSelectedUser?.user_name ?? "",
    },
    {
      key: "name",
      current: license?.master_name ?? "",
      new: newSelectedUser?.first_name ?? "" + " " + newSelectedUser?.last_name ?? "",
    },
  ];



  const TransferLicense = useTransferLicense();
  const confirmExecuteTransfer = useConfirm(
    async () => {

      let payload = {
        "existing_user_reference_id": license.master_user_id,
        "new_user_reference_id": newSelectedUser.id,
        "serial_number": license.serial_number
      }
      console.log(payload)
      let newEntity: any = await TransferLicense({
        existing_user_reference_id: license.master_user_id,
        new_user_reference_id: newSelectedUser.id,
        serial_number: license.serial_number
      });
      console.log("newEntity", newEntity)
      if (onCloseDrawer) onCloseDrawer()

    },

    {
      translationPrefix: [
        "licenses.basic.detail",
        "transfer",
      ].join("."),

      width: "580px",
      content: (
        <FullWidthSpace direction="vertical" size="middle">
          <Title level={4}>{t("licenses.basic.detail.transfer.title")}</Title>
          <Title level={5}>{t("licenses.basic.detail.transfer.warning_message")}</Title>
          <Row >
            <Col xs={24} md={24}>
              <Space direction="vertical" size="middle">
                <LabeledItem
                  label={t("licenses.basic.detail.form.label.serial_number")}
                  content={license.serial_number}
                  fallback={t("global.fallback.none")}
                />
              </Space>
            </Col>
          </Row>
          <Row >
            <Col xs={24} md={24}>
              <Title level={5}>{t("licenses.basic.detail.transfer.owner")}</Title>

              <Table

                columns={columns}
                dataSource={data}
                bordered
                pagination={false}
                sticky
              />




            </Col>
          </Row>
        </FullWidthSpace>
      ),


    }
  );


  return (

    <>
      <Button
        type="primary"

        onClick={() => {

          confirmExecuteTransfer();

        }}
      >
        {t("licenses.basic.detail.transfer.button_confirm_execute")}
      </Button></>
  );
};
